/**
 * useAuthContext Hook
 * Custom hook to use Auth Context
 */

import { useContext } from 'react';
import { AuthContext, type AuthContextType } from './AuthContextDefinition';

export const useAuthContext = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
};
